import React, { useEffect, useMemo, useRef, useState } from 'react';
import JoditEditor from 'jodit-react';

const EmailComponent = ({ formData, setFormData }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(formData?.template_content || '');
  const [dirty, setDirty] = useState(false);

  // Keep editor in sync with incoming template content, but never overwrite once user starts editing.
  useEffect(() => {
    if (!dirty) {
      setContent(formData?.template_content || '');
    }
  }, [formData?.template_content, dirty]);

  const baseEmailBodyCSS = useMemo(
    () =>
      [
        // Base typography for email composing
        'body, .jodit-wysiwyg { font-family: "Khmer UI", Geneva, sans-serif; font-size: 14px; line-height: 1.4; }',
        // Prevent large gaps when `enter: "P"` creates paragraphs
        '.jodit-wysiwyg p { margin: 0; }',
        // Keep lists usable/consistent
        '.jodit-wysiwyg ul, .jodit-wysiwyg ol { margin: 0; padding-left: 1.25rem; }',
        '.jodit-wysiwyg li { margin: 0; }',
        // Ensure unstyled spans inherit editor base
        '.jodit-wysiwyg span { font-family: inherit; font-size: inherit; line-height: inherit; }',
      ].join('\n'),
    []
  );

  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      toolbarAdaptive: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      toolbarSticky: false,
      // Paste behavior: no popup, clean HTML automatically
      askBeforePasteHTML: false,
      defaultActionOnPaste: 'insert_clear_html',
      enter: 'P',
      nl2br: false,
      cleanHTML: {
        fillEmptyParagraph: false,
      },
      placeholder: '',
      // Works for both iframe and non-iframe modes (Jodit uses one depending on config/version).
      style: baseEmailBodyCSS,
      iframeStyle: baseEmailBodyCSS,
      buttons: [
        'bold', 'italic', 'underline', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|',
        'font', 'fontsize', 'brush', 'paragraph', '|',
        'image', 'video', 'table', 'link', '|',
        'align', 'undo', 'redo', '|',
        'hr', 'copyformat', 'symbol', 'print', 'about', '|',
        'fullsize', 'source'
      ]
    }),
    [baseEmailBodyCSS]
  );

  return (
    <div className="tmsEmailEditor">
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onChange={(newContent) => {
          setDirty(true);
          setContent(newContent);
          setFormData((prev) => ({ ...prev, template_content: newContent }));
        }}
        onBlur={(newContent) => {
          // Keep blur as a final sync point (some browsers/editors apply changes on blur).
          setDirty(true);
          setContent(newContent);
          setFormData((prev) => ({ ...prev, template_content: newContent }));
        }}
      />
    </div>
  );
};
export default EmailComponent;
